import { ASYNC_STATUS } from 'utils/constants/flow.constant';
import { FLOW_STATUS } from 'utils/ignoramusEnums';
import { initialFlows } from 'pages/Flow/MockData/flowData';


export const DEFAULT_START_LEVEL_VALUE = 'Begin at *';

export const DEFAULT_PAUSE_LEVEL_VALUE = 'Pause at (optional)*';

export const getNodesCompleteDetailsInitialState = () => ({
  nodesCompleteDetails: {
    status: ASYNC_STATUS.IDLE,
    error: false,
  },
});

export const initialState = {
  summaries: [],
  summariesLoading: false,
  listOfFlows: initialFlows,
  flowNodesAndEdgesLoaded: false,
  nodes: [],
  edges: [],
  ...getNodesCompleteDetailsInitialState(),
  flowsCache: initialFlows,
  cleanRoomFlow: {
    flowVersion: null,
    flow: {
      ID: '',
      title: '',
      description: '',
      tags: [],
      stage: FLOW_STATUS.MISSING_DATASETS.key,
      version: null,
      currentVersion: null,
    },
  },
  flow: {
    ID: '',
    title: '',
    description: '',
    tags: [],
    stage: FLOW_STATUS.MISSING_DATASETS.key,
  },
  nodesEdgeConnectionDialog: {
    open: false,
  },
  nodeSize: 'MD',
  selectedStartLevel: DEFAULT_START_LEVEL_VALUE,
  selectedPauseLevel: DEFAULT_PAUSE_LEVEL_VALUE,
  isFlowCachedMode: false,
  includedNodeIds: [],
};
